import { useIvyChatStore } from '@/stores/ivyChatStore';
import { Wand2, Video, Mic, Pencil, Music, BarChart3 } from 'lucide-react';

const SUGGESTIONS = [
  { icon: Video, label: '/create-video', description: 'Create a video from a topic' },
  { icon: Mic, label: '/narrate', description: 'Add narration to a project' },
  { icon: Pencil, label: '/edit-slide', description: 'Edit a slide in a project' },
  { icon: Music, label: '/audio-first', description: 'Create video from audio' },
  { icon: BarChart3, label: '/video-status', description: 'Check project status' },
];

export function IvyWelcome() {
  const sendMessage = useIvyChatStore(s => s.sendMessage);

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-16">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-brand/10 mb-5">
          <Wand2 className="w-7 h-7 text-brand" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground mb-2">Ivy Chat</h1>
        <p className="text-muted-foreground text-sm max-w-md">
          Create, narrate, and edit AI-powered videos. Start a conversation or pick a workflow.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-2 max-w-xl">
        {SUGGESTIONS.map(({ icon: Icon, label, description }) => (
          <button
            key={label}
            onClick={() => sendMessage(label)}
            className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl
              bg-surface border border-border-secondary hover:border-border
              transition-all duration-150 group text-left"
          >
            <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center group-hover:bg-accent transition-colors">
              <Icon className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors" />
            </div>
            <div>
              <div className="text-sm font-medium text-foreground">{label}</div>
              <div className="text-xs text-muted-foreground">{description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
